export default __webpack_public_path__ + "static/media/gas-book.8a436c50.png";